module.exports = __webpack_public_path__ + "static/media/7.8ae36601.jpg";